import { observer } from "mobx-react"
import React, { Component } from "react"
import { Dropdown } from "semantic-ui-react"
import languageStore from "stores/languageStore"


@observer
export default class LanguageDropdown extends Component {

  render() {
    const { currentLanguage } = languageStore
    if ( languageStore.available.length <= 1 ) return null
    return <Dropdown
      text={currentLanguage.toUpperCase()}
      pointing
      className="link item">
      <Dropdown.Menu>
        {languageStore.available.map( locale => <Dropdown.Item
          key={locale}
          onClick={() => languageStore.setLanguage( locale )}>{locale}</Dropdown.Item> )}
      </Dropdown.Menu>
    </Dropdown>
  }
}


// WEBPACK FOOTER //
// ./src/components/Language/LanguageDropdown.js